import { ITheme } from "@theme/index";

const getStyles = (theme: ITheme) => ({
    mainWrapper: {
        root: {
            background: theme.semanticColors.bodyBackground,
            padding: `${theme.spacing.s8} ${theme.spacing.s7}`
        }
    },
    logoSection: {
        root:{
            width: '50%'
        }
    },

})
export default getStyles;